import { takeLeading, takeEvery } from 'redux-saga/effects';

import { LOGOUT } from '@crm-framework/auth';

import { chatActions } from '../store';

import {
  handleInitChats,
  handleGetChatMessages,
  handleSendMessage,
  handleSearch,
  handleInit,
  handleRefreshChat,
  handleLogout,
  handleInitCreatedChat,
  handleGetIsLeadChatsEnable,
} from './sagas';
import {
  handleStartCall,
  handleDiscardCall,
  handleSendSdp,
  handleOnIceCandidate,
  handleConnectionStateChange,
  handleChangeClientMute,
  handleCallSignalingData,
  handleCallStateChange,
} from './call';
import { handleGroupContactImport } from './groupTgContactImport';
export { getToken as getXChatToken } from './utils';

export function* watchChatSagas() {
  yield takeLeading(chatActions.init, handleInit);
  yield takeLeading(chatActions.initChats, handleInitChats);
  yield takeLeading(chatActions.initCreatedChat, handleInitCreatedChat);
  yield takeLeading(chatActions.getChatMessages, handleGetChatMessages);
  yield takeLeading(chatActions.sendMessage, handleSendMessage);
  yield takeLeading(chatActions.searchChat, handleSearch);
  yield takeLeading(
    chatActions.checkLeadChatButtonEnable,
    handleGetIsLeadChatsEnable
  );
  yield takeEvery(chatActions.refreshChat, handleRefreshChat);
  yield takeEvery(chatActions.startCall, handleStartCall);
  yield takeEvery(chatActions.callState, handleCallStateChange);
  yield takeEvery(chatActions.discardCall.type, handleDiscardCall);
  yield takeEvery(chatActions.sendSdp, handleSendSdp);
  yield takeEvery(chatActions.addCallSignalingData, handleCallSignalingData);

  yield takeEvery(chatActions.onIceCandidate, handleOnIceCandidate);
  yield takeEvery(
    chatActions.connectionStateChange,
    handleConnectionStateChange
  );
  yield takeEvery(chatActions.changeClientMute, handleChangeClientMute);
  yield takeEvery(LOGOUT, handleLogout);

  yield takeEvery(chatActions.groupContactImport, handleGroupContactImport);
}
